/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Ad_TitleInputs */

const en_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Ads`)
};

const ar_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إزالة الإعلانات`)
};

const de_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigen entfernen`)
};

const es_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina los anuncios`)
};

const fr_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les publicités`)
};

const it_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi annunci`)
};

const ja_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告を削除`)
};

const ko_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`광고 제거`)
};

const pt_br_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remoção de anúncios`)
};

const ru_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удаление рекламы`)
};

const th_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลบโฆษณา`)
};

const tr_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reklamları Kaldır`)
};

const zh_cn_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无广告干扰`)
};

const zh_tw_subscription_exclusive_feature_ad_title = /** @type {(inputs: Subscription_Exclusive_Feature_Ad_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無廣告干擾`)
};

/**
* | output |
* | --- |
* | "Remove Ads" |
*
* @param {Subscription_Exclusive_Feature_Ad_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_ad_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Ad_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Ad_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_ad_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_ad_title(inputs)
	return zh_tw_subscription_exclusive_feature_ad_title(inputs)
});